const $ = window.jQuery
const ajax = $ && $.ajax
export { $, ajax }
